export const GOOGLE_API_KEY = 'AIzaSyBa_LpVVmrT4Apqu_axgiX_Ou4wdnGgGk8';
export const GOOGLE_MAPS_SCRIPT = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_API_KEY}`
  + '&libraries=places,geometry';
export const SMARTY_STREETS_WEB_KEY = '10745329668025033';
export const SMARTY_STREETS_AUTOCOMPLETE_API = 'https://smartystreets.matic.com/lookup';

